import styled from '@emotion/styled';
import { Button, Divider, Tabs } from 'antd';
import { useEffect, useState } from 'react';
import { FaArrowLeft, FaDownload } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { ORANGE, PRIMARY, YELLOW } from '../../../../shared/colors';
import { Layout } from '../../../shared/Layout';
import { BGGlobale } from '../components/Balances/globale';
import { BGTitre } from '../components/Balances/titre';
import { BGTitulaire } from '../components/Balances/titulaire';
import { BGTresor } from '../components/Balances/tresor';
import { exportBGData } from '../components/exportDataExcel';
import { getBalance } from '../network';

const Container = styled.div`
  height: calc(100vh - 30px);
  display: flex;
  background-color: #1c2025;
  color: white;

  .bread-crum span {
    color: white;
  }

  td.ant-table-column-sort {
    background-color: transparent !important;
  }

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  .odd-row {
    background-color: #757575;
    color: white;
  }

  .even-row {
    background-color: #acacac;
    color: white;
  }

  .odd-row,
  .even-row {
    &:hover > td {
      background-color: ${YELLOW} !important;
      cursor: pointer;
      color: black; /* plus lisible */
    }
  }

  .content {
    padding: 50px;
    width: 100%;
    background-color: #1c2025;
    color: white;
  }
`;

export const BalanceGeneralPage = () => {
  const [tabIndex, setTabIndex] = useState('1');
  const [balances, setBalances] = useState<any>();
  const history = useHistory();
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;

  useEffect(() => {
    getBalance(connectedUser.id).then(({ data }) => {
      setBalances(data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout hideYellowScrollInfo>
      <Container>
        {/** Obtain 'current' values in Sidebar component */}
        <div className='content'>
          <h2 style={{ marginTop: 10, color: 'white' }}>
            Comptabilité - Balance Générale
          </h2>
          <div style={{ marginTop: 20 }}>
            <div
              style={{
                borderRadius: '50%',
                padding: 5,
                backgroundColor: ORANGE,
                width: 40,
                height: 40,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                marginBottom: 5,
              }}
              onClick={() => history.goBack()}
            >
              <FaArrowLeft size={20} />
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'right',
              }}
            >
              <Button
                icon={
                  <FaDownload style={{ marginBottom: -2, marginRight: 5 }} />
                }
                className='butt'
                style={{ borderRadius: 5 }}
                onClick={() => exportBGData(balances)}
              >
                Exporter
              </Button>
            </div>
            <Divider />

            <Tabs
              defaultActiveKey='1'
              activeKey={tabIndex}
              style={{ color: 'white' }}
              type='line'
              onChange={(key: string) => setTabIndex(key)}
              size='small'
            >
              <Tabs.TabPane tab='Balance Globale' key='1'>
                <BGGlobale bg={balances?.globale || []} />
              </Tabs.TabPane>
              <Tabs.TabPane tab='Balance par Titre' key='2'>
                <BGTitre bg={balances?.titre || []} />
              </Tabs.TabPane>
              <Tabs.TabPane tab='Balance par Trésor' key='3'>
                <BGTresor bg={balances?.tresor || []} />
              </Tabs.TabPane>
              <Tabs.TabPane tab='Balance par Titulaire' key='4'>
                <BGTitulaire bg={balances?.titulaire || []} />
              </Tabs.TabPane>
            </Tabs>
          </div>
        </div>
      </Container>
    </Layout>
  );
};
